import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { isValidationError } from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { performIssueGetRequest } from '@atlassian/jira-issue-reliability-fetch/src/index.tsx';
import type { Options, FetchProjectsResponse } from '../../../common/types.tsx';
import { mapDataToOptions } from '../../../common/utils.tsx';

export const fetchProjects = async (
	inputValue: string,
	autoCompleteUrl: string,
): Promise<Options> =>
	performIssueGetRequest(
		`${autoCompleteUrl}${inputValue}`,
		undefined,
		'fields/project/src/ui/edit/async-project-cf/utils',
	)
		.then((response: FetchProjectsResponse) => mapDataToOptions(response.values))
		.catch((error) => {
			trackFetchErrors({
				error,
				id: 'fetchProjects',
				packageName: 'jiraIssueFieldProject',
				logToSentry: !isValidationError(error),
				sendToPrivacyUnsafeSplunk: true,
			});
			throw error;
		});
